/**
 * Returns true if Segment should be disabled.
 * Checks the Rails-injected window flag, with a query param override for local dev testing.
 */
export const isSegmentMigrationEnabled = (): boolean => {
  const searchString = window.location?.search ?? '';
  const params = new URLSearchParams(searchString);
  const queryOverride = params.get('segment_migration');

  // Only exact string 'true' enables; any other value explicitly disables.
  if (queryOverride !== null) {
    return queryOverride === 'true';
  }

  return window.signupSegmentMigrationEnabled === true;
};
